enum Feature {
  FEATURE_CONTACT_US,
  FEATURE_VIEW_RESOURCES,
  FEATURE_TUTORIAL,
  FEATURE_VIEW_MANUAL,
  FEATURE_SHARE_IDEAS,
  FEATURE_NEWS,
  FEATURE_HOME,
  FEATURE_VIEW_TRAINING,
}

export default Feature;
